import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';
import { Storage, Token } from '@/utils';
Vue.use(Router)

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import '../my-theme/index.less';
Vue.use(iView);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login')
    },
    {
        path: '/index',
        name: 'index',
        redirect: "/index/setting",
        component: () => import('../views/Main'),
        children: [
            {
                path: 'setting',
                name: 'setting',
                component: () => import('../views/setting/setting')
            },
            {
                path: 'userConfiguration',
                name: 'userConfiguration',
                component: () => import('../views/userConfiguration')
            },
            {
                path: 'addUserConfiguration',
                name: 'addUserConfiguration',
                component: () => import('../views/userConfiguration/Add')
            },
            {
                path: 'MenuBuilder',
                name: 'MenuBuilder',
                component: () => import('../views/setting/menuBuilder/MenuBuilder')
            },
            {
                path: 'AddThemesLayouts',
                name: 'AddThemesLayouts',
                component: () => import('../views/setting/menuBuilder/themes/AddThemesLayouts')
            },
            {
                path: 'ThemesLayouts',
                name: 'ThemesLayouts',
                component: () => import('../views/setting/menuBuilder/themes/ThemesLayouts')
            },
            {
                path: 'CompanyConfiguration',
                name: 'CompanyConfiguration',
                component: () => import('../views/setting/companyConfiguration/Index')
            },
            {
                path: 'addCompanyConfiguration',
                name: 'addCompanyConfiguration',
                component: () => import('../views/setting/companyConfiguration/Add')
            },
            {
                path: 'siteConfiguration',
                name: 'siteConfiguration',
                component: () => import('../views/setting/siteConfiguration/Index')
            },
            {
                path: 'addSiteConfiguration',
                name: 'addSiteConfiguration',
                component: () => import('../views/setting/siteConfiguration/Add')
            },
            {
                path: 'reports',
                name: 'reports',
                component: () => import('../views/setting/reports/Index')
            },
            {
                path: 'adminreports',
                name: 'adminreports',
                component: () => import('../views/setting/adminreports/Index')
            },
        ]
    }
];


const router = new Router({
    mode: "hash",
    routes: routes
})


const whiteList = ['/login'];
router.beforeEach(async (to, from, next) => {
    iView.LoadingBar.start();
    if(Token.getToken()){
        if (to.path === '/login') {
            next();
        } else if (!store.state.common.isGetUserInfo) {
            try {
                await store.dispatch('common/GetUserInfo');
                next();
            } catch (e) {
                store.dispatch('common/LogOut');
            }
        } else {
            next();
            iView.LoadingBar.finish();
        }
    } else if (whiteList.indexOf(to.path) !== -1) {
        next();
        iView.LoadingBar.finish();
    } else {
        next('/login');
        iView.LoadingBar.finish();
    }
});

router.afterEach(to => {
    iView.LoadingBar.finish();
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js